import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { nonEmptyHtml, ShEditorComponent } from '@shs-digi-care-monorepo/frontend-lib';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';

export type SetRequestOnHoldDialogData = Record<string, never>;
export interface SetRequestOnHoldDialogResult {
    comment: string;
}

@Component({
    selector: 'app-set-request-on-hold-dialog',
    templateUrl: './set-request-on-hold-dialog.component.html',
    imports: [
        TranslateModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ShEditorComponent,
        DialogWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SetRequestOnHoldDialog {
    private readonly dialogRef = inject<MatDialogRef<SetRequestOnHoldDialog>>(MatDialogRef);
    public data = inject<SetRequestOnHoldDialogData>(MAT_DIALOG_DATA);

    protected formGroup = new FormGroup({
        comment: new FormControl<string>('', { nonNullable: true, validators: [nonEmptyHtml] })
    });

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        if (this.formGroup.invalid) return;
        this.dialogRef.close(this.formGroup.getRawValue());
    }
}
